import { render, staticRenderFns } from "./achievementStudent.vue?vue&type=template&id=7972bcf2&scoped=true"
import script from "./achievementStudent.vue?vue&type=script&lang=js"
export * from "./achievementStudent.vue?vue&type=script&lang=js"
import style0 from "./achievementStudent.vue?vue&type=style&index=0&id=7972bcf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7972bcf2",
  null
  
)

export default component.exports